// extracted by mini-css-extract-plugin
export default {"menu-view__title":"v_b7 my-2 p-2","menu-view__tile-row":"v_b8 d-flex"};